define('ordersDetailMessagesView',[
  'module',
  'underscore',
  'headerFooterView', 
  'ordersDetailMessagesBodyView',
  'ordersDetailMessagesFooterView'
], function (
  Module,
  _,
  HeaderFooterView,  
  BodyView,
  FooterView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'orders-detail-messages-view ' + HeaderFooterView.prototype.className,    
    childView: BodyView,
    childFooterView: FooterView,
    ticket: null,

    initialized: function () { 
      HeaderFooterView.prototype.initialized.call(this);
      
      if(this.view)
        this.view.on('scrooltop', _.bind(this.onScrooltop, this));        
      
      if(this.footerView)
        this.footerView.on('scrooltop', _.bind(this.onScrooltop, this));    
    },

    onScrooltop: function () {
      var scrollHeight = this.ui.bodyRegion[0].scrollHeight;
      this.ui.bodyRegion.scrollTop(scrollHeight - this.ui.bodyRegion.height());
    }
  });
});

